export default __webpack_public_path__ + "static/media/restaurant-8-rMAX.3e645fa7.jpg";